// Sustituto de 'firebase/messaging' con Web Push estándar (servidor propio).
// El "token" es la suscripción Web Push en JSON; se guarda en fcmTokens como antes.
import { apiCall } from './wire.js';

const SW_URL = '/push-sw.js';
const SW_SCOPE = '/push/';
const messagingInstance = { app: null };
const foregroundHandlers = new Set();

export const getMessaging = () => messagingInstance;
export const isSupported = async () =>
  typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

function urlB64ToUint8Array(base64) {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(b64);
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

async function registration() {
  const existing = await navigator.serviceWorker.getRegistration(SW_SCOPE);
  if (existing && existing.active && existing.active.scriptURL.endsWith(SW_URL)) return existing;
  const reg = await navigator.serviceWorker.register(SW_URL, { scope: SW_SCOPE });
  if (!reg.active) {
    await new Promise((resolve) => {
      const sw = reg.installing || reg.waiting;
      if (!sw) return resolve();
      sw.addEventListener('statechange', () => { if (sw.state === 'activated') resolve(); });
      setTimeout(resolve, 5000);
    });
  }
  return reg;
}

export async function getToken() {
  if (!(await isSupported())) return null;
  if (Notification.permission !== 'granted') return null;
  const { publicKey } = await apiCall('/push/vapid', null, { method: 'GET', auth: false });
  if (!publicKey) return null;
  const reg = await registration();
  const key = urlB64ToUint8Array(publicKey);
  let sub = await reg.pushManager.getSubscription();
  if (sub) {
    const current = sub.options && sub.options.applicationServerKey ? new Uint8Array(sub.options.applicationServerKey) : null;
    if (current && (current.length !== key.length || current.some((b, i) => b !== key[i]))) {
      await sub.unsubscribe();
      sub = null;
    }
  }
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  return JSON.stringify(sub.toJSON());
}

export async function deleteToken() {
  try {
    const reg = await navigator.serviceWorker.getRegistration(SW_SCOPE);
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    if (sub) await sub.unsubscribe();
    return true;
  } catch {
    return false;
  }
}

if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
  navigator.serviceWorker.addEventListener('message', (e) => {
    if (!e.data || e.data.type !== 'tp-push') return;
    const p = e.data.payload || {};
    const payload = {
      notification: { title: p.title, body: p.body, image: p.image, icon: p.icon },
      data: p.data || {},
      fcmOptions: { link: p.link },
    };
    for (const fn of foregroundHandlers) {
      try { fn(payload); } catch (err) { console.error(err); }
    }
  });
}

export function onMessage(messaging, handler) {
  const fn = typeof handler === 'function' ? handler : handler && handler.next;
  foregroundHandlers.add(fn);
  return () => foregroundHandlers.delete(fn);
}
